export default __webpack_public_path__ + "static/media/portrait15.c7af3aa9.jpg";